@if (showBlockingModal()) {
<div
  class="fa-overlay fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0F1B2D]/70 backdrop-blur-md antialiased">
  <article
    class="fa-card relative w-full max-w-[480px] rounded-[28px] overflow-hidden bg-[#0F1B2D] text-white shadow-[0_30px_80px_-20px_rgba(0,0,0,0.7)] border border-hs-blue/25">
    <div class="absolute top-0 inset-x-0 h-[3px] bg-gradient-to-r from-hs-blue to-[#b30000]"></div>

    <div class="px-10 pt-12 pb-9 flex flex-col gap-6">
      <div
        class="fa-d-1 flex items-center gap-2.5 text-[10px] font-medium uppercase tracking-[0.24em] text-hs-blue">
        <span class="size-1.5 rounded-full bg-hs-blue shadow-[0_0_10px_rgba(244,0,0,0.7)] animate-pulse"></span>
        Acesso encerrado
        <span class="flex-1 h-px bg-gradient-to-r from-hs-blue/50 to-transparent ml-2"></span>
      </div>

      <h2 class="fa-d-2 text-3xl md:text-[2.5rem] font-extrabold text-white tracking-tight leading-[1.05]">
        Seu plano gratuito acabou
      </h2>

      <p class="fa-d-3 text-[0.95rem] leading-relaxed text-white/70">
        O plano Freemium foi descontinuado e seu acesso à plataforma foi encerrado.
        Para retomar a operação com todas as funcionalidades, é necessário assinar o plano Otimiza.
      </p>

      <div class="fa-d-4 grid grid-cols-2 gap-px bg-white/10 rounded-2xl border border-white/10 overflow-hidden">
        <div class="px-4 py-3.5 bg-[#0F1B2D] flex flex-col gap-1">
          <span class="text-[9.5px] font-medium uppercase tracking-[0.22em] text-hs-blue/70">Plano sugerido</span>
          <span class="text-[1.05rem] font-bold text-white">Otimiza</span>
        </div>
        <div class="px-4 py-3.5 bg-[#0F1B2D] flex flex-col gap-1">
          <span class="text-[9.5px] font-medium uppercase tracking-[0.22em] text-hs-blue/70">Investimento</span>
          <span class="text-[1.05rem] font-bold text-white">
            R$ 399 <span class="text-[0.7rem] font-normal text-white/50">/mês</span>
          </span>
        </div>
      </div>

      <button type="button" (click)="openOtimiza()"
        class="fa-d-5 group w-full py-4 px-6 rounded-full bg-hs-blue text-white font-semibold text-[0.95rem] hover:bg-hs-active hover:-translate-y-px hover:shadow-[0_14px_36px_-10px_rgba(0,0,40,0.45)] transition-all duration-200 flex items-center justify-center gap-2">
        Assinar plano Otimiza
        <span class="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
      </button>

      <button type="button" (click)="logout()"
        class="fa-d-6 w-full py-2 text-[11px] uppercase tracking-[0.2em] text-white/45 hover:text-white hover:tracking-[0.26em] transition-all duration-200">
        Sair da conta
      </button>
    </div>
  </article>
</div>
}

@if (showOtimizaModal()) {
<app-modal-plano-otimiza (closeModal)="closeOtimiza()"></app-modal-plano-otimiza>
}
